"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function cov_bdofzkz3() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronLeft16.tsx";
  var hash = "9e48bb8222fc477695a1acfa31f2de745a16fdfd";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChevronLeft16.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 55
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "9e48bb8222fc477695a1acfa31f2de745a16fdfd"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_bdofzkz3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_bdofzkz3();
var Icon = (cov_bdofzkz3().s[0]++, {
  name: 'chevron-left-16',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10.8839 13.8839C10.3957 14.372 9.60427 14.372 9.11612 13.8839L4.11612 8.88388C3.8817 8.64946 3.75 8.33152 3.75 8C3.75 7.66848 3.8817 7.35054 4.11612 7.11612L9.11612 2.11612C9.60427 1.62796 10.3957 1.62796 10.8839 2.11612C11.372 2.60427 11.372 3.39573 10.8839 3.88388L6.76777 8L10.8839 12.1161C11.372 12.6043 11.372 13.3957 10.8839 13.8839Z\" fill=\"currentColor\"/>"
});
var _default = exports["default"] = Icon;